import type { DeepWiden } from '../types'

export const id = {
  meta: {
    localeName: 'Bahasa Indonesia',
    htmlLang: 'id',
  },
  nav: {
    home: 'Beranda',
    cahaya: '7 Cahaya',
    expedition: 'Ekspedisi',
    science: 'Sains',
    about: 'Tentang',
    join: 'Bergabung',
    menu: 'Menu',
    close: 'Tutup menu',
    open: 'Buka menu',
  },
  common: {
    skipToContent: 'Lompat ke konten utama',
    learnMore: 'Selengkapnya',
    backHome: 'Kembali ke beranda',
    comingSoon: 'Segera hadir',
    draftBadge: 'Data sementara',
    draftHint: 'Angka masih estimasi perencanaan dan menunggu verifikasi ephemeris.',
    verifiedBadge: 'Terverifikasi',
    primaryBadge: 'Lokasi utama',
    placeholder: 'Konten menyusul',
    switchLanguage: 'Ganti bahasa',
    basedIn: 'Berbasis di Indonesia',
  },
  hero: {
    eyebrow: '2 Agustus 2027 · Makkah, Arab Saudi',
    title: 'Gerhana Matahari Total 2027',
    theme: 'Ekspedisi 7 Cahaya',
    lead: 'Satu peristiwa langit, tujuh jalur cahaya. Riset sains, ekspedisi Makkah, dan pengamatan lintas jalur totalitas — dirangkai menjadi satu program peradaban.',
    ctaPrimary: 'Lihat 7 Cahaya',
    ctaSecondary: 'Ikut ekspedisi',
  },
  countdown: {
    heading: 'Hitung mundur menuju totalitas',
    subheading: 'Menuju kontak kedua di Makkah (AST, UTC+3)',
    daysShort: 'Hari',
    hoursShort: 'Jam',
    minutesShort: 'Menit',
    secondsShort: 'Detik',
    calendarViewLabel: 'Dalam bulan dan minggu',
    months: 'Bulan',
    weeks: 'Minggu',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    seconds: 'Detik',
    statusBefore: 'Menghitung mundur menuju totalitas',
    statusPartial: 'Fase sebagian sedang berlangsung',
    statusTotality: 'TOTALITAS SEDANG BERLANGSUNG',
    statusAfter: 'Gerhana telah usai',
    makkahTime: 'Waktu Makkah',
    localTime: 'Waktu Anda',
  },
  timeline: {
    eyebrow: 'Lini masa',
    heading: 'Lini masa gerhana di Makkah',
    lead: 'Lima kontak utama, ditampilkan dalam waktu Makkah dan waktu perangkat Anda.',
    contacts: {
      partialBegin: 'Gerhana sebagian dimulai',
      totalityBegin: 'Totalitas dimulai',
      maximum: 'Puncak gerhana',
      totalityEnd: 'Totalitas berakhir',
      partialEnd: 'Gerhana sebagian berakhir',
    },
    totalityDuration: 'Durasi totalitas',
    safetyNote:
      'Gunakan pelindung mata bersertifikat ISO 12312-2 pada seluruh fase sebagian. Mata telanjang hanya aman selama totalitas penuh.',
  },
  cahaya: {
    eyebrow: 'Tema program',
    heading: 'Ekspedisi 7 Cahaya',
    lead: 'Tujuh cahaya yang menuntun seluruh kegiatan GMT 2027 — dari laboratorium hingga jalur totalitas.',
    pillarLabel: 'Cahaya',
    draftNotice:
      'Setiap cahaya adalah sebuah gerakan dengan hasil kerjanya masing-masing. Ini adalah draf awal — uraian dan hasil kerja masih disempurnakan tim program.',
    draftBadge: 'Draf awal',
    deliverables: 'Hasil kerja',
    pillarLeadLabel: 'Pemimpin pilar',
    leadPerson: 'Pemimpin',
    leadOrganization: 'Organisasi pendukung',
    toBeAnnounced: 'Akan diumumkan',
  },
  expedition: {
    eyebrow: 'Ekspedisi',
    heading: 'Menyusuri jalur totalitas',
    lead: 'Makkah menjadi titik utama. Sejumlah lokasi lain di sepanjang jalur totalitas disiapkan sebagai stasiun pengamatan pendukung.',
    sitesHeading: 'Kandidat lokasi pengamatan',
    duration: 'Durasi totalitas',
    sunAltitude: 'Ketinggian Matahari',
    coordinates: 'Koordinat',
    note: 'Daftar lokasi masih terbuka. Kelayakan akhir bergantung pada perizinan, cuaca klimatologis, dan kesiapan logistik.',
  },
  science: {
    eyebrow: 'Sains',
    heading: 'Eksperimen dan pengumpulan data',
    lead: 'Gerhana total adalah laboratorium alam yang hanya terbuka lima menit. Setiap eksperimen dirancang agar dapat direplikasi oleh sekolah, komunitas, dan peneliti.',
    protocolHeading: 'Protokol',
    equipment: 'Peralatan',
    difficulty: 'Tingkat kesulitan',
    difficultyLevels: {
      school: 'Sekolah',
      community: 'Komunitas',
      research: 'Riset',
    },
    placeholderNotice:
      'Daftar eksperimen masih berupa kerangka. Protokol lengkap akan diterbitkan bersama panduan lapangan.',
  },
  about: {
    eyebrow: 'Tentang',
    heading: 'Tentang GMT 2027',
    lead: 'GMT 2027 adalah program publik menyambut Gerhana Matahari Total 2 Agustus 2027 dengan tema Ekspedisi 7 Cahaya.',
    missionHeading: 'Yang kami kerjakan',
    contactHeading: 'Kontak',
    placeholderNotice: 'Profil lembaga, susunan tim, dan mitra akan dilengkapi kemudian.',
  },
  join: {
    eyebrow: 'Bergabung',
    heading: 'Ikut serta dalam GMT 2027',
    lead: 'Daftarkan minat Anda sebagai peserta ekspedisi, relawan pengamatan, atau mitra program.',
    newsletterHeading: 'Kabar terbaru',
    newsletterLead: 'Dapatkan pembaruan jadwal, protokol eksperimen, dan pembukaan pendaftaran.',
  },
  form: {
    name: 'Nama lengkap',
    email: 'Alamat email',
    organization: 'Institusi / komunitas',
    role: 'Peran yang diminati',
    roles: {
      participant: 'Peserta ekspedisi',
      volunteer: 'Relawan pengamatan',
      researcher: 'Peneliti',
      partner: 'Mitra / sponsor',
      media: 'Media',
    },
    site: 'Lokasi pengamatan pilihan',
    message: 'Catatan tambahan',
    optional: 'opsional',
    submit: 'Kirim pendaftaran',
    submitting: 'Mengirim…',
    subscribe: 'Berlangganan',
    successTitle: 'Terima kasih',
    successBody: 'Data Anda tersimpan. Tim kami akan menghubungi melalui email.',
    errorGeneric: 'Pengiriman gagal. Silakan coba lagi beberapa saat lagi.',
    errorOffline:
      'Pendaftaran daring akan segera dibuka. Sementara ini, silakan hubungi kami melalui email:',
    requiredField: 'Wajib diisi',
    invalidEmail: 'Format email belum benar',
  },
  footer: {
    tagline: 'Ekspedisi 7 Cahaya',
    safety: 'Selalu gunakan pelindung mata bersertifikat ISO 12312-2 selama fase sebagian.',
    navHeading: 'Navigasi',
    contactHeading: 'Kontak',
    rights: 'Seluruh hak cipta dilindungi.',
    dataNote: 'Waktu kontak Makkah mengacu pada AST (UTC+3).',
  },
  notFound: {
    title: 'Halaman tidak ditemukan',
    lead: 'Tautan yang Anda tuju mungkin sudah berpindah atau belum tersedia.',
  },
} as const

/** Every other locale must match this shape exactly. */
export type Dictionary = DeepWiden<typeof id>
